export const OMS_2_FEATURE_FLAG = 'oms-2.0';
export const CRM_FEATURE_FLAG = 'crm';
export const QUOTES_FEATURE_FLAG = 'quotes';
export const REPORTS_FEATURE_FLAG = 'reports';
